import React, { useState } from 'react';

const ChecksList = ({ payment }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!payment.checks || payment.checks.length === 0) {
    return null;
  }

  const getStatusBadge = (status) => {
    const statusColors = {
      pending: 'bg-yellow-100 text-yellow-700',
      cleared: 'bg-green-100 text-green-700',
      bounced: 'bg-red-100 text-red-700',
      cancelled: 'bg-gray-100 text-gray-700'
    };

    const statusLabels = {
      pending: 'ממתין',
      cleared: 'פרוע',
      bounced: 'חזר',
      cancelled: 'מבוטל'
    };

    return (
      <span className={`px-2 py-1 text-xs rounded-full ${statusColors[status]}`}>
        {statusLabels[status]}
      </span>
    );
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('he-IL', {
      style: 'currency',
      currency: 'ILS'
    }).format(amount);
  };

  return (
    <tr className="bg-gray-50">
      <td colSpan={7} className="px-2 py-2">
        <div className="bg-white rounded-lg border border-gray-200">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full px-3 py-2 flex items-center justify-between hover:bg-gray-50"
          >
            <div className="flex items-center gap-2">
              <svg
                className={`h-4 w-4 text-gray-500 transform transition-transform ${isExpanded ? 'rotate-90' : ''}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
              <div className="text-xs font-semibold text-gray-700 flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2">
                <span>{payment.checks.length} צ'קים</span>
                <span className="text-gray-500">בנק: {payment.bank_number} | סניף: {payment.branch_number}</span>
              </div>
            </div>
            <div className="text-xs sm:text-sm font-bold text-primary-600 whitespace-nowrap">
              {formatCurrency(payment.checks.reduce((sum, check) => sum + parseFloat(check.amount), 0))}
            </div>
          </button>

          {isExpanded && (
            <div className="border-t border-gray-200 p-2 sm:p-3">
              <div className="overflow-x-auto">
                <table className="min-w-full text-xs">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-2 py-1.5 text-right text-xs font-medium text-gray-600">
                        מס' צ'ק
                      </th>
                      <th className="px-2 py-1.5 text-right text-xs font-medium text-gray-600">
                        תאריך
                      </th>
                      <th className="px-2 py-1.5 text-right text-xs font-medium text-gray-600">
                        סכום
                      </th>
                      <th className="px-2 py-1.5 text-right text-xs font-medium text-gray-600">
                        סטטוס
                      </th>
                      <th className="px-2 py-1.5 text-right text-xs font-medium text-gray-600 hidden sm:table-cell">
                        הערות
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {payment.checks.map((check, index) => (
                      <tr key={check.id || index} className="hover:bg-gray-50">
                        <td className="px-2 py-2 text-xs font-medium text-gray-900">
                          {check.check_number}
                        </td>
                        <td className="px-2 py-2 text-xs text-gray-700 whitespace-nowrap">
                          {new Date(check.check_date).toLocaleDateString('he-IL', {
                            day: '2-digit',
                            month: '2-digit'
                          })}
                        </td>
                        <td className="px-2 py-2 text-xs font-semibold text-green-600 whitespace-nowrap">
                          {formatCurrency(check.amount)}
                        </td>
                        <td className="px-2 py-2">
                          {getStatusBadge(check.status)}
                        </td>
                        <td className="px-2 py-2 text-xs text-gray-500 hidden sm:table-cell">
                          <div className="max-w-[100px] truncate" title={check.notes || '-'}>
                            {check.notes || '-'}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="bg-gray-100">
                    <tr>
                      <td colSpan="2" className="px-2 py-1.5 text-xs font-bold text-gray-700 text-left">
                        סה"כ:
                      </td>
                      <td className="px-2 py-1.5 text-xs font-bold text-green-600 whitespace-nowrap">
                        {formatCurrency(payment.checks.reduce((sum, check) => sum + parseFloat(check.amount), 0))}
                      </td>
                      <td colSpan="2"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {payment.notes && (
                <div className="mt-2 p-2 bg-blue-50 rounded-lg">
                  <div className="text-xs font-semibold text-gray-600 mb-0.5">הערות כלליות:</div>
                  <div className="text-xs text-gray-700">{payment.notes}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default ChecksList;

